import { useRecoilState } from "recoil";
import ContentBox from "../ContentBox";
import { recoilStates } from "src/recoil/recoilStates";
import Button from "../Button";
import styled from "styled-components";
import { dateFormat } from "src/utils";
import Stepper from "../Stepper/index2";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAlert } from "../../hooks";

export default function HasBooking() {
  const [group] = useRecoilState(recoilStates.group);
  const [user] = useRecoilState(recoilStates.user);
  const [bookingApplication] = useRecoilState(recoilStates.eventApplication);
  const members = bookingApplication?.members;

  const clubRelData = bookingApplication?.event_booking_rel_club?.find((cr) => cr.status_id === 5);

  const myMemberData = members?.find((m) => {
    return m.teeshot_user_id && m.teeshot_user_id === user.id;
  });

  const navigate = useNavigate();
  const alert = useAlert();
  const [eventPayNotied, setEventPayNotied] = useRecoilState(recoilStates.eventPayNotied);

  useEffect(() => {
    if (!bookingApplication) {
      return;
    }

    if (bookingApplication.is_paid) {
      return;
    }
    if (eventPayNotied) {
      console.log("eventPayNotied :", eventPayNotied);
      return;
    }

    alert({
      content: "보증금(환불)과 이용수수료 페이지로 이동합니다.",
      onClose: () => {
        navigate("/event-booking/payment");
        setEventPayNotied(1);
      },
    });
    // await alert.pause()
  }, [bookingApplication]);

  // FaCoins

  const isPaid = bookingApplication?.is_paid;
  const memberRegistered = bookingApplication?.members && bookingApplication?.members.length > 1;
  const tarRel = bookingApplication?.event_booking_rel_club?.find((cr) => cr.status_id === 5);
  const isTeamResgistered = tarRel?.roundDates?.some((rd) => rd.is_fixed);
  const isTeetimeRegistered = tarRel?.roundDates?.some((rd) =>
    rd?.teams?.some((t) => t?.teeoff_time)
  );

  const checkId = () => {
    if (!isPaid) {
      return "-1";
    }
    if (!memberRegistered) {
      return 0;
    }
    if (!isTeamResgistered) {
      return 1;
    }
    if (!isTeetimeRegistered) {
      return 2;
    }
    if (isTeetimeRegistered) {
      return 3;
    }
    return "-1";
  };
  const stepId = checkId();
  const checkCommnet = (() => {
    const idMap = {
      "-1": "보증금/수수료 납부하세요.",
      0: "멤버 등록하세요.",
      1: "조편성 후 제출하세요.",
      2: "조별 티타임 등록 기다려주세요.",
      3: "라운딩 확정!",
    };
    return idMap[stepId];
  })();

  return (
    <Container className="d-flex fd-c gap-2">
      <Stepper
        className="page-pd-negative-side page-pd-negative-top"
        currentIdx={stepId as number}
        stepsXpadding="40px"
        // title="멤버 등록 후 조편성하세요~"
        title={checkCommnet}
        steps={[
          { label: "보증금", icon: "money" },
          { label: "멤버등록", icon: "invite-member" },
          { label: "조편성", icon: "group-register" },
          { label: "라운딩확정", icon: "confirm-club" },
        ]}
      />
      <h4 className="bold">다음 라운드 정보</h4>

      {clubRelData?.roundDates?.map((round) => {
        const myTeam = round?.teams?.find((team) => {
          return team.members?.some((mr) => {
            return mr.event_booking_member_id === myMemberData?.id;
          });
        });
        return (
          <div key={`round-${round.id}`}>
            <ContentBox
              header={<></>}
              content={
                <div className="card d-flex flex-1 fd-c gap-2 jc-sa">
                  <div className="row">
                    <div className="col head">클럽명</div>
                    <div className="col content">{clubRelData?.club?.name}</div>
                  </div>
                  <div className="row">
                    <div className="col head">행사명</div>
                    <div className="col content">{bookingApplication?.event_name}</div>
                  </div>
                  <div className="row">
                    <div className="col head">일시</div>
                    <div className="col content">
                      {dateFormat(new Date(round.round_date || ""))}{" "}
                      {myTeam?.teeoff_time || round.teeoff_time}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col head">락커</div>
                    <div className="col content">
                      {(() => {
                        const myTeamMemberData = myTeam?.members?.find(
                          (m) => m.event_booking_member_id === myMemberData?.id
                        );
                        if (!myTeamMemberData) {
                          return "미정";
                        }
                        return myTeamMemberData.locker_number || "미정";
                      })()}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col head">팀원</div>
                    <div className="col content">
                      {(() => {
                        const team = round?.teams?.find((team) => {
                          return team.members?.some((mr) => {
                            return mr.event_booking_member_id === myMemberData?.id;
                          });
                        });
                        if (!team) {
                          return "미정";
                        }

                        const names = team?.members?.map((m) => {
                          return members?.find((_m) => _m.id === m.event_booking_member_id)?.name;
                        });
                        return names?.join(", ");
                      })()}
                    </div>
                  </div>
                </div>
              }
            />
          </div>
        );
      })}

      <div className="d-flex fd-c ai-c">
        <p>월 부킹관련 문의</p>
        <p>티샷: 02-2277-3489 </p>
      </div>

      <Button
        className="mt-2"
        $colorTheme="green"
        $buttonSize="md"
        $round
        onClick={() => {
          navigate("/event-booking/member-list");
        }}
      >
        멤버등록
      </Button>
      <Button
        className="mt-"
        $colorTheme="green"
        $buttonSize="md"
        $round
        onClick={() => {
          navigate("/event-booking/team-register");
        }}
      >
        조 편성
      </Button>
    </Container>
  );
}

const Container = styled.div`
  > * {
    font-size: 18px;
  }

  .card {
    .row {
      display: flex;
      gap: 10px;
      .col {
        &.head {
          flex-basis: 55px;
          font-weight: bold;
          display: flex;
          justify-content: flex-end;
        }
        &.content {
          flex: 1;
        }
      }
    }

    .group-img {
      /* width: 50px;
      height: 50px; */
    }
    .round-content {
      > div {
        display: flex;
        > div:nth-child(2) {
          flex: 1;
          display: flex;
          justify-content: center;
        }
      }
    }

    .head-col {
      width: 60px;
    }
  }
`;
